import { createAsyncThunk } from '@reduxjs/toolkit';
import type { DefaultThunkConfig } from '@/app/providers/storeProvider';
import type { AxiosError } from 'axios';
import type { AppAxiosErrorPayload } from '@/z-shared/api';
import type { UserInfo } from '@/z-shared/lib/types/userInfo';

export const requestUserInfo = createAsyncThunk<UserInfo, undefined, DefaultThunkConfig>(
    'auth/requestUserInfo',
    async (_, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        try {
            const { data } = await extra.api.get<UserInfo>('/users/me');
            return data;
        }
        catch (e) {
            const error = e as AxiosError<AppAxiosErrorPayload>;
            return rejectWithValue(error.response?.data);
        }
    },
);
